import { getState } from '@web/common/ExternalConfig/ExternalConfig'
import locale from '@web/common/locale'
import { ClubInApp, Question, translate, PointsInfo, AppsflyerSmartBanner, MobileAppWebBottomBar, MobileAppDesktopQrModal, CareServicesUrls, ExternalConfigCourseIds, ExternalConfigNewHome } from '@web/store/types/modules/assets'
import getBaseUrl from '@web/common/getBaseUrl'

const defaultCourseIds: number[] = [
  39,
  49,
  50,
  51,
  53,
  55,
  56,
  62,
  65,
  82,
  103,
  122,
  124,
  125,
  139,
  159,
  162,
  172,
  174,
  177,
  183,
  185,
  194,
  219,
  223,
  230,
  243,
  257,
  276,
  277,
  279,
  282,
  287,
  302,
  315,
  320,
  324,
  325,
  326,
  328,
  329,
  331,
  332,
  336,
  337,
  338,
  344,
  345,
  346,
  349,
  360,
  364,
  373,
  377,
  313,
  237,
  311,
  133,
  139,
  140,
  143,
  160,
  171,
  196,
  201,
  216,
  228,
  197,
  200,
  213,
  218,
  288,
  327,
  339
]
const defaultRecommendedCourseIds: number[] = [124, 194]
const defaultNewCourseIds: number[] = [377, 327, 103]
const defaultTopSaleCourseIds: number[] = [287, 124]
const defaultTriggerCourseId = 233 // Id course on PROD
const defaultTriggerStartDate = 1760475600000 // 15.10.25 00:00:00

export const isOfflineEnable = (): boolean => Boolean(getState().data.isOfflineEnable)
export const isUserAnonAuthEnable = (): boolean => Boolean(getState().data.isUserAnonAuthEnable)
export const isRegistrationEnable = (): boolean => Boolean(getState().data.isRegistrationEnable)

export const passHomeworkSupportCategoryId = (): number | undefined => getState().data.passHomeworkSupportCategoryId
export const renewCourseSupportCategoryId = (): number | undefined => getState().data.renewCourseSupportCategoryId
export const renewConsultationSupportCategoryId = (): number | undefined => getState().data.renewConsultationSupportCategoryId

export const welcomeMessages = (): translate[] => getState().data?.userInfoChat?.welcomeMessages || []
export const questions = (): Question[] => getState().data?.userInfoChat?.questions || []
export const goodbyeMessages = (): translate[] => getState().data?.userInfoChat?.goodbyeMessages || []

export const minSaveViewedMS = (): number | undefined => getState().data?.statistic?.MIN_SAVE_VIEWED_MS
export const minSaveViewedMSDayStatusFinished = (): number | undefined => getState().data?.statistic?.MIN_SAVE_VIEWED_MS_VIDEO_ENDED
export const timeoutSaveStatistic = (): number | undefined => getState().data?.statistic?.TIMEOUT_SAVE_STATISTIC
export const messageDelay = (): number => getState().data?.messageDelay || 15
export const isDemoAccessible = (): boolean => Boolean(getState().data.isDemoAccessible)
export const isVideoConsultationSupport = (): boolean => Boolean(getState().data.isVideoConsultationSupport)
export const isBannerEnable = (): boolean => Boolean(getState().data.isBannerEnable)
export const saleEmail = (): string => getState().data.saleEmail || 'sale@anyclass.com'
export const isAppStoreSupport = (): boolean => Boolean(getState().data.isAppStoreSupport)
export const daysShowWarning = (): number => getState().data.daysShowWarning || 0
export const isChatSupport = (): boolean => Boolean(getState().data.isChatSupport)
export const socialAuth = (): { android: string[]; ios: string[] } => getState().data.socialAuth
export const daysNoticeRenew = (): number => getState().data.daysShowWarning || 3
export const instructionUrl = (): string => getState().data.instructionUrl?.[locale.get()] || ''
export const guidelineUrl = (): string => getState().data.guidelineUrl?.[locale.get()] || ''
export const communityUrlFrontend = (): string => getState().data.communityUrlFrontend || ''
export const communityUrlApi = (): string => {
  const url = getState().data.communityUrlApi || ''
  return url ? new URL(getBaseUrl(url), window.location.toString()).toString() : ''
}
export const clubInApp = (): ClubInApp => getState().data.clubInApp || {}
export const pointsInfo = (): PointsInfo => getState().data.pointsInfo || {
  countPointsToDebit: 200,
  links: {},
  faq: []
}
export const cookiePolicyLink = (): string => getState().data.cookiePolicyLink || ''
export const appsflyerSmartBanner = (): AppsflyerSmartBanner => getState().data.appsflyerSmartBanner || {}
export const mobileAppWebBottomBar = (): MobileAppWebBottomBar => getState().data.mobileAppWebBottomBar || { visible: false }
export const mobileAppDesktopQrModal = (): MobileAppDesktopQrModal => getState().data.mobileAppDesktopQrModal || { visible: false }
export const careServicesUrls = (): CareServicesUrls => getState().data.careServicesUrls || { telegram: '', whatsapp: '' }
export const newHome = (): ExternalConfigNewHome => getState().data.newHome || {
  courseIds: {
    all: defaultCourseIds,
    recommended: defaultRecommendedCourseIds,
    new: defaultNewCourseIds,
    topSale: defaultTopSaleCourseIds
  },
  triggerCourseId: defaultTriggerCourseId,
  triggerStartDate: defaultTriggerStartDate
}
export const courseIds = (): ExternalConfigCourseIds => getState().data.newHome?.courseIds || {
  all: defaultCourseIds,
  recommended: defaultRecommendedCourseIds,
  new: defaultNewCourseIds,
  topSale: defaultTopSaleCourseIds
}
export const allCourseIds = (): number[] => getState().data.newHome?.courseIds?.all || defaultCourseIds
export const recommendedCourseIds = (): number[] => getState().data.newHome?.courseIds?.recommended || defaultRecommendedCourseIds
export const newCourseIds = (): number[] => getState().data.newHome?.courseIds?.new || defaultNewCourseIds
export const topSaleCourseIds = (): number[] => getState().data.newHome?.courseIds?.topSale || defaultTopSaleCourseIds
export const triggerCourseId = (): number => getState().data.newHome?.triggerCourseId || defaultTriggerCourseId
export const triggerStartDate = (): number => getState().data.newHome?.triggerStartDate || defaultTriggerStartDate
